/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAppMessagesV2} from '../api'

 export const useQueryGetAppMessagesV2 = createReactQueryHook('getAppMessagesV2', getAppMessagesV2)
